export default __webpack_public_path__ + "static/media/36I-102741_-15818_0.d9fc6965.jpg";